import { configureStore } from '@reduxjs/toolkit';
import commonReducer from './slice/CommonSlice';
import { reducer as oidcReducer } from 'redux-oidc';
import subscriptionReducer from '../redux/oidc/reducers/subscriptionReducer';
import cachingReducer from '../redux/oidc/reducers/cachingReducer';
import functionReducer from '../redux/oidc/reducers/functionReducer';
import tableReducer from './slice/TableSile.js';
import userReducer from './slice/userSlice.js';

const store = configureStore({
    reducer: {
        commonReducer: commonReducer.reducer,
        tableReducer: tableReducer.reducer,
        // oidc: oidcReducer,
        userReducer: userReducer.reducer,
        subscription: subscriptionReducer,
        caching: cachingReducer,
        functions: functionReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default store;
